import { FiltersStrattoAvailability } from "./FiltersStratto";

export default FiltersStrattoAvailability;
